module.exports = __webpack_public_path__ + "static/media/bg.a5133af1.png";